import { Tooltip, Button } from 'antd'
import Feather from '@sysunite/react-feather'

const FreezeGraphButton = ({ freezeGraph, isFrozen }) => {

  return (
    <Tooltip placement="bottomLeft"
      trigger="hover"
      mouseEnterDelay={1}
      title="Freeze/Unfreeze the graph"
    >
      <Button
        onClick={freezeGraph}
        type="link"
        icon={<Feather size="1.5em" type="pause" />}
        className={isFrozen && 'active'}
      />
    </Tooltip>
  )
}

export default FreezeGraphButton
